/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'carbon-components-react';
import { api } from '../../helpers/api/api';
import propTypes from 'prop-types';

const download = (blob, fileName) => {
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement('a');
    // Browsers that support HTML5 download attribute
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export default class FileDownLoadButton extends Component {
  constructor(props) {
    super(props);
    // bind event handlers
    this.downloadFile = this.downloadFile.bind(this);
  }

  downloadFile = async () => {
    try {
      this.props.onDownLoadStart();
      const file = this.props.method === 'post' && this.props.postBody !== null ? (await api.postBlob(this.props.apiUrl, this.props.postBody)).data : (await api.getBlob(this.props.apiUrl)).data;
      return download(file, this.props.fileName);
    } catch (error) {
        console.error(error);
      return this.props.onError(error);
    } finally {
      this.props.onDownLoadEnd();
    }
  };

  startDownLoad = async (url, name) => {
    const file = (await api.getBlob(url)).data;
    return download(file, name);
  };

  render() {
    const { ...buttonProps } = this.props;
    delete buttonProps.fileName;
    delete buttonProps.apiUrl;
    delete buttonProps.method;
    delete buttonProps.postBody;
    delete buttonProps.onDownLoadStart;
    delete buttonProps.onDownLoadEnd;
    delete buttonProps.onError;
    return <Button onClick={this.downloadFile} {...buttonProps} />;
  }
}

FileDownLoadButton.propTypes = {
  apiUrl: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  method: propTypes.string,
  postBody: propTypes.object,
  onDownLoadStart: PropTypes.func,
  onDownLoadEnd: PropTypes.func,
  onError: PropTypes.func,
};
FileDownLoadButton.defaultProps = {};
